<script setup>
// AC-Group-Patch: bettet die glue-Admin-UI ein und übergibt den Chatwoot-Login-Token (?cwt=)
// für die serverseitige Rechteprüfung. URL relativ → funktioniert pro Mandant automatisch.
import { computed } from "vue";
import { useStore } from "vuex";
const store = useStore();
const src = computed(() => {
  const t = store.getters.getCurrentUser?.access_token || "";
  return "/glue/admin/skills/ui?cwt=" + encodeURIComponent(t);
});
</script>

<template>
  <div class="flex flex-col w-full h-full bg-n-background">
    <iframe :src="src" title="Skill-Routing" class="flex-1 w-full border-0" style="min-height: 100vh" />
  </div>
</template>
